let _nextDraftId = -1;

export function nextDraftId() {
  return _nextDraftId--;
}

export function peekNextDraftId() {
  return _nextDraftId;
}
